import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, CardBody, Input, Button, Label, Spinner } from 'reactstrap';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { toast } from 'react-toastify';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import { notification } from '../../component/hocs/notification';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const RawStockIn = () => {
  const [formData, setFormData] = useState({
    raw_material_name: '',
    stock_in: '',
    uom_id: '',
    vendor_code: '',
    transaction_date: new Date().toISOString().split('T')[0],
  });

  const [uomOptions] = useState([
    { id: 1, name: 'Kilogram' },
    { id: 2, name: 'Gram' },
    { id: 3, name: 'Piece' },
    { id: 4, name: 'Liter' },
    { id: 5, name: 'Milliliter' },
  ]);
  
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch initial data on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchRawMaterialList();
    fetchVendors();
  }, []);

  // Fetch raw material list from API
  const fetchRawMaterialList = async () => {
    try {
      const response = await axios.get(`${mainurl}raw_list`);
      if (Array.isArray(response.data.data)) {
        setRawMaterialList(response.data.data);
      } else {
        console.error('Invalid data structure received for raw materials');
      }
    } catch (err) {
      console.error('Error fetching raw material list:', err);
      notification({ type: 'error', message: 'Error while fetching raw material list', position: 'bottom' });
    }
  };

  // Fetch vendor list from API
  const fetchVendors = async () => {
    try {
      const response = await axios.get(`${mainurl}view_vendor`);
      if (Array.isArray(response.data.data)) {
        setVendorOptions(response.data.data);
      } else {
        setError('Invalid data structure received for vendors');
      }
    } catch (err) {
      setError('Failed to fetch vendors');
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${mainurl}raw_in`, formData);
      if (response.status === 200) {
        toast.success('Raw material added successfully');
        resetForm();
      } else {
        setError('Failed to create');
        toast.error('Failed to create');
      }
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err);
      setError('Failed to create');
      toast.error('Failed to create');
    } finally {
      setLoading(false);
    }
  };

  // Reset form fields
  const resetForm = () => {
    setFormData({
      raw_material_name: '',
      stock_in: '',
      uom_id: '',
      vendor_code: '',
      transaction_date: new Date().toISOString().split('T')[0],
    });
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-3">
            <Title pageTitle="Raw Stock In" />
          </Col>
          <Col xs={12}>
            <Card color="primary" outline className="mb-3">
              <CardBody>
                <Row className="my-2">
                  <Col md={6}>
                    <Label>Raw Material Name</Label>
                    <Input
                      type="select"
                      value={formData.raw_material_name}
                      onChange={(e) => setFormData({ ...formData, raw_material_name: e.target.value })}
                      required
                    >
                      <option value="">Select Raw Material</option>
                      {rawMaterialList.map((material) => (
                        <option key={material.raw_material_id} value={material.raw_material_name}>
                          {material.raw_material_name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={6}>
                    <Label>Vendor Code</Label>
                    <Input
                      type="select"
                      value={formData.vendor_code}
                      onChange={(e) => setFormData({ ...formData, vendor_code: e.target.value })}
                      required
                    >
                      <option value="">Select Vendor Code</option>
                      {vendorOptions.map((vendor) => (
                        <option key={vendor.vendor_code} value={vendor.vendor_code}>
                          {vendor.vendor_code} - {vendor.vendor_name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                <Row className="my-2">
                  <Col md={6}>
                    <Label>Stock In Quantity</Label>
                    <Input
                      type="number"
                      value={formData.stock_in}
                      onChange={(e) => setFormData({ ...formData, stock_in: e.target.value })}
                      placeholder="Stock In Quantity"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Unit of Measurement (UOM)</Label>
                    <Input
                      type="select"
                      value={formData.uom_id}
                      onChange={(e) => setFormData({ ...formData, uom_id: e.target.value })}
                      required
                    >
                      <option value="">Select UOM</option>
                      {uomOptions.map((uomOption) => (
                        <option key={uomOption.id} value={uomOption.id}>
                          {uomOption.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                <Row className="my-2">
                  <Col md={6}>
                      <Label>Transaction Date</Label>
                      <DatePicker
                        selected={formData.transaction_date ? new Date(formData.transaction_date) : null}
                        onChange={(date) => setFormData({ ...formData, transaction_date: date })}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select a date"
                        className="form-control"
                        required
                      />
                    </Col>
                  </Row>
                <Button
                  className="mt-3"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : 'Save Product'}
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default RawStockIn;
